import enMessages from "./locales/en.json";
import en from "react-intl/locale-data/en";
import { addLocaleData } from "react-intl";
import moment from "moment";
import { UPDATE, updateIntlAction } from "actions/localizationActions";

// const defaultlanguage = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;

// function getLanguageWithOutRegionCode(language) {
//   return language.toLowerCase().split(/[_-]+/)[0];
// }

// function getMessage(selectedMessage) {
//   switch (selectedMessage) {
//   case "zh":
//     return zhMessages;
//   default:
//     return enMessages;
//   }
// }

const mapLocaleForMoment = (locale = "") => {
  switch (locale.toLowerCase()) {
    case "en":
    case "en-us":
    case "en-sg":
      return "en-gb"; // We're using en-gb date format from moment.js when locale is english
    default:
      return locale;
  }
};

export const initialLocalState = {
  defaultLocale: "en-SG",
  locale: "en-SG",
  messages: enMessages,
  formats: {
    number: {
      money: {
        currency: "SGD",
        style: "currency",
        currencyDisplay: "symbol",
      },
    },
    date: {
      short: {},
    },
  },
};

export function updateIntl(language, languageCode, unformattedLangCode, messages) {
  return dispatch => {
    import(`react-intl/locale-data/${language}`)
    .then(localeData => {
        addLocaleData(localeData);
      })
      .then(() => {
        let localeCode = mapLocaleForMoment(unformattedLangCode);
        // Update zh-cn/zh-hk moment locale to include "month" chinese character
        if (localeCode === "zh-cn" || localeCode === "zh-hk") {
          moment.updateLocale(localeCode, {
            longDateFormat: {
              ll: "YYYY年M月D日",
            },
          });
        } else {
          moment.locale(localeCode);
        }

        dispatch(
          updateIntlAction({
            locale: localeCode === "zh-hk"? "zh-Hans-HK" : language,
            messages: messages ? messages : enMessages, //getMessage(language)
          })
        );
      });
  };
}

export function addSupportLocal() {
  return Promise.resolve(addLocaleData(en));
}

export function initialLocal(callBack) {
  if (!window.Intl) {
    require.ensure(["intl", "intl/locale-data/jsonp/en.js"], require => {
      require("intl");
      require("intl/locale-data/jsonp/en.js");
      callBack();
    });
  } else {
    callBack();
  }
  moment.locale("en-gb"); // Using en-gb (moment.js) to format the date on intial state
}

export function intlReducer(state = initialLocalState, action) {
  if (action.type !== UPDATE) {
    return state;
  }

  return { ...state, ...action.payload };
}



// WEBPACK FOOTER //
// ./i18n/ReduxIntl.js